import type { SearchScenarioId } from 'owa-search-store';
import { action } from 'satcheljs';

/**
 * Action that the consuming client should dispatch if it wants to show/hide
 * the suggestions dropdown.
 */
export interface SET_IS_SUGGESTIONS_DROPDOWN_VISIBLEActionMessage {
    isSuggestionsDropdownVisible: boolean;
    scenarioId: SearchScenarioId;
}
export const setIsSuggestionsDropdownVisible: (
    isSuggestionsDropdownVisible: boolean,
    scenarioId: SearchScenarioId
) => SET_IS_SUGGESTIONS_DROPDOWN_VISIBLEActionMessage = action(
    'SET_IS_SUGGESTIONS_DROPDOWN_VISIBLE',
    (
        isSuggestionsDropdownVisible: boolean,
        scenarioId: SearchScenarioId
    ): SET_IS_SUGGESTIONS_DROPDOWN_VISIBLEActionMessage => ({
        isSuggestionsDropdownVisible,
        scenarioId,
    })
);
